import styled, { css } from 'styled-components';
const DirectionModifiers = {
    row: (theme) => css `
    flex-direction: row;
  `,
    rowReverse: (theme) => css `
    flex-direction: row-reverse;
  `,
    column: (theme) => css `
    flex-direction: column;
  `,
    columnReverse: (theme) => css `
    flex-direction: column-reverse;
  `
};
const AlignContentModifiers = {
    stretch: (theme) => css `
    align-content: stretch;
  `,
    center: (theme) => css `
    align-content: center;
  `,
    flexStart: (theme) => css `
    align-content: flex-start;
  `,
    flexEnd: (theme) => css `
    align-content: flex-end;
  `,
    spaceBetween: (theme) => css `
    align-content: space-between;
  `,
    spaceAround: (theme) => css `
    align-content: space-around;
  `
};
const AlignItemsModifiers = {
    flexStart: (theme) => css `
    align-items: flex-start;
  `,
    center: (theme) => css `
    align-items: center;
  `,
    flexEnd: (theme) => css `
    align-items: flex-end;
  `,
    stretch: (theme) => css `
    align-items: stretch;
  `,
    baseline: (theme) => css `
    align-items: baseline;
  `
};
const justifyModifiers = {
    flexStart: (theme) => css `
    justify-content: flex-start;
  `,
    center: (theme) => css `
    justify-content: center;
  `,
    flexEnd: (theme) => css `
    justify-content: flex-end;
  `,
    spaceBetween: (theme) => css `
    justify-content: space-between;
  `,
    spaceAround: (theme) => css `
    justify-content: space-around;
  `,
    spaceEvenly: (theme) => css `
    justify-content: space-evenly;
  `
};
export const Container = styled.div `
  ${({ direction, alignContent, alignItems, justify, theme }) => css `
    max-width: 1366px;
    padding: 24px;
    margin: 0 auto;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    ${direction && DirectionModifiers[direction](theme)}
    ${alignContent && AlignContentModifiers[alignContent](theme)}
    ${alignItems && AlignItemsModifiers[alignItems](theme)}
    ${justify && justifyModifiers[justify](theme)}
    &:before,
    &:after {
      content: ' ';
      display: table;
    }
    &:after {
      clear: both;
    }
  `}
`;
export const Row = styled.div `
  width: 100%;
  height: auto;
  float: left;
  box-sizing: border-box;
  &:before,
  &:after {
    content: ' ';
    display: table;
  }
`;
const getWidthGridInline = (value, paddingValue) => {
    if (!value)
        return;
    const width = (value / 12) * 100;
    const padding = paddingValue / (12 / value);
    return `width: calc(${width}% - ${padding}px)`;
};
export const ColumnInline = styled.div `
  ${({ mobile, tablet, desktop, hugeDesktop, spacing }) => css `
    display: inline-block;
    min-height: 1px;
    box-sizing: border-box;
    width: 100%;
    @media only screen and (max-width: 768px) {
      ${mobile && getWidthGridInline(mobile, 20)};
      padding: ${`${spacing && spacing * 0.5}rem`};
    }
    @media only screen and (min-width: 768px) {
      ${tablet && getWidthGridInline(tablet, 44)};
      padding: ${`${spacing && spacing * 0.5}rem`};
    }
    @media only screen and (min-width: 1170px) {
      ${desktop && getWidthGridInline(desktop, 50)};
      padding: ${`${spacing && spacing * 1}rem`};
    }
    @media only screen and (min-width: 1440px) {
      ${hugeDesktop && getWidthGridInline(hugeDesktop, 50)};
      padding: ${`${spacing && spacing * 1}rem`};
    }
  `}
`;
const getWidthGrid = (value) => {
    if (!value)
        return;
    const width = (value / 12) * 100;
    return `width: ${width}%`;
};
export const Column = styled.div `
  ${({ mobile, tablet, desktop, spacing, hugeDesktop }) => css `
    float: left;
    min-height: 1px;
    box-sizing: border-box;
    width: 100%;
    @media only screen and (max-width: 768px) {
      ${mobile && getWidthGrid(mobile)};
      padding: ${`${spacing && spacing * 0.5}rem`};
    }
    @media only screen and (min-width: 768px) {
      ${tablet && getWidthGrid(tablet)};
      padding: ${`${spacing && spacing * 0.5}rem`};
    }
    @media only screen and (min-width: 1172px) {
      ${desktop && getWidthGrid(desktop)};
      padding: ${`${spacing && spacing * 1}rem`};
    }
    @media only screen and (min-width: 1440px) {
      ${hugeDesktop && getWidthGrid(hugeDesktop)};
      padding: ${`${spacing && spacing * 1}rem`};
    }
  `}
`;
//# sourceMappingURL=GridSystem.js.map